var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageRec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_60018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4451 104.143V102.286C46.4451 90.3552 46.4451 78.4249 46.4451 66.4801C46.4451 54.6223 54.6485 46.451 66.5544 46.4365C88.8563 46.4365 111.158 46.4365 133.474 46.4365C145.366 46.4365 153.555 54.6223 153.555 66.4946C153.555 88.9184 153.555 111.328 153.555 133.751C153.555 137.757 152.64 141.458 150.346 145.043C149.881 144.651 149.475 144.318 149.097 143.969C127.028 123.897 104.973 103.81 82.9178 83.7224C80.464 81.4873 79.1718 81.4002 76.4276 83.3161C66.9174 89.9489 57.4072 96.5817 47.897 103.2C47.505 103.476 47.0839 103.722 46.4451 104.143ZM120.465 94.7674C128.915 94.7965 135.812 87.9314 135.812 79.4989C135.812 71.1535 128.959 64.2595 120.639 64.2014C112.189 64.1433 105.307 70.9358 105.249 79.4119C105.176 87.8734 111.986 94.7384 120.48 94.7674H120.465Z",
    fill: "url(#paint0_linear_121_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.829 150.428C141.562 152.562 138.092 153.549 134.346 153.549C122.687 153.549 111.042 153.549 99.3829 153.549C88.3482 153.549 77.2989 153.549 66.2642 153.549C54.7503 153.549 46.4597 145.261 46.4307 133.737C46.4307 127.496 46.4597 121.241 46.4016 115C46.4016 113.941 46.7065 113.302 47.5922 112.692C57.6687 105.726 67.7451 98.7302 77.7635 91.662C78.9106 90.8492 79.5494 90.9363 80.5513 91.8506C99.8185 109.441 119.115 127.003 138.411 144.565C140.516 146.481 142.607 148.382 144.829 150.414V150.428Z",
    fill: "url(#paint1_linear_121_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27 164.26C164.27 158.396 164.256 152.779 164.27 147.148C164.27 144.753 165.562 142.823 167.668 142.068C169.788 141.299 171.864 141.56 173.33 143.302C174.158 144.303 174.869 145.754 174.898 147.017C175.044 154.55 175 162.068 174.956 169.601C174.942 172.721 172.648 174.942 169.512 174.971C162.034 175.014 154.571 175 147.094 174.971C143.957 174.971 141.576 172.619 141.562 169.659C141.533 166.625 143.928 164.303 147.181 164.274C152.205 164.245 157.214 164.274 162.237 164.274C162.847 164.274 163.443 164.274 164.256 164.274L164.27 164.26Z",
    fill: "url(#paint2_linear_121_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27 35.7253C158.361 35.7253 152.684 35.7689 146.992 35.7108C143.202 35.6673 140.691 32.1694 141.852 28.6716C142.549 26.5671 144.466 25.0577 146.774 25.0432C154.411 24.9996 162.049 24.9851 169.7 25.0432C172.633 25.0577 174.927 27.3218 174.956 30.2536C175.014 37.8443 175.014 45.4205 174.956 53.0112C174.942 56.0446 172.561 58.3088 169.613 58.2943C166.68 58.2943 164.314 56.0156 164.285 52.9822C164.227 47.9024 164.27 42.8371 164.27 37.7573C164.27 37.1477 164.27 36.5526 164.27 35.7253Z",
    fill: "url(#paint3_linear_121_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7298 164.26C36.4848 164.26 37.0801 164.26 37.6754 164.26C42.7427 164.26 47.8245 164.216 52.8918 164.274C55.9118 164.303 58.1768 166.669 58.1768 169.615C58.1768 172.562 55.9263 174.927 52.8918 174.956C45.3707 175.014 37.8496 175 30.3286 174.956C27.3231 174.942 25.058 172.634 25.029 169.615C24.9854 162.097 24.9854 154.564 25.029 147.046C25.0435 143.984 27.3521 141.734 30.2996 141.691C33.3051 141.662 35.6717 143.955 35.7008 147.075C35.7443 152.141 35.7008 157.22 35.7153 162.286C35.7153 162.881 35.7153 163.476 35.7153 164.245L35.7298 164.26Z",
    fill: "url(#paint4_linear_121_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7298 35.7257C35.7298 41.5457 35.7589 47.1626 35.7298 52.7794C35.7153 55.7547 33.7116 57.9753 30.9384 58.2511C27.8458 58.5414 25.0871 56.3062 25.0581 53.2148C24.9709 45.5225 24.9855 37.8302 25.0581 30.1524C25.0726 27.2932 27.3521 25.0726 30.227 25.0435C37.8061 24.9855 45.3852 24.9855 52.9644 25.0435C55.9699 25.0581 58.2204 27.4819 58.1914 30.4282C58.1623 33.3599 55.8973 35.6821 52.8482 35.7112C47.839 35.7692 42.8153 35.7257 37.8061 35.7257C37.1963 35.7257 36.5865 35.7257 35.7443 35.7257H35.7298Z",
    fill: "url(#paint5_linear_121_60018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.131 79.514C128.131 83.7375 124.69 87.1628 120.48 87.1483C116.269 87.1483 112.828 83.6795 112.842 79.485C112.842 75.2615 116.269 71.8652 120.509 71.8652C124.719 71.8652 128.131 75.2905 128.131 79.514Z",
    fill: "url(#paint6_linear_121_60018)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_60018",
    x1: 99.9999,
    y1: 46.4365,
    x2: 99.9999,
    y2: 145.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_60018",
    x1: 95.6151,
    y1: 91.1045,
    x2: 95.6151,
    y2: 153.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_60018",
    x1: 158.28,
    y1: 141.658,
    x2: 158.28,
    y2: 174.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_60018",
    x1: 158.283,
    y1: 25.0049,
    x2: 158.283,
    y2: 58.2943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_60018",
    x1: 41.5866,
    y1: 141.69,
    x2: 41.5866,
    y2: 174.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_121_60018",
    x1: 41.5948,
    y1: 25,
    x2: 41.5948,
    y2: 58.2764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_121_60018",
    x1: 120.487,
    y1: 71.8652,
    x2: 120.487,
    y2: 87.1483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_60018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRec);
export default __webpack_public_path__ + "static/media/Image_Rec.9346e7c7c506ee4d230c948815cb1d97.svg";
export { ForwardRef as ReactComponent };